// extracted by mini-css-extract-plugin
module.exports = {"teamMember":"TeamMember_teamMember__1bVcH","avatar":"TeamMember_avatar__1Z1U0","text":"TeamMember_text__2s5rL"};